import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
// import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FondoDenominacion } from 'src/app/models/dash';
import { AsignarFondoService } from 'src/app/services/asignar-fondo.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Component({
  selector: 'app-bitacora',
  templateUrl: './bitacora.component.html',
  styleUrls: ['./bitacora.component.scss']
})
export class BitacoraComponent implements OnInit {

  verDetalle: boolean = false;
  showAreaNota: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    public asignarFondo: AsignarFondoService,
    private store: Store<AppState>,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {

  }

  openModal() {
    this.verDetalle = true;
    this.showAreaNota = false;
  }

  closeModal() {
    this.verDetalle = false;
    this.showAreaNota = false;
  }

  openSeguimiento() {
    this.showAreaNota = true;
  }

  saveSeguimiento() {
    this.toastr.success(`Nota agregada correctamente`, 'Correcto', { positionClass: 'toast-bottom-right' } );
  }
  
}
